import { render, staticRenderFns } from "./BuscarVerificacionyDetalle_Historico.vue?vue&type=template&id=de64efb6&scoped=true"
import script from "./BuscarVerificacionyDetalle_Historico.vue?vue&type=script&lang=js"
export * from "./BuscarVerificacionyDetalle_Historico.vue?vue&type=script&lang=js"
import style0 from "./BuscarVerificacionyDetalle_Historico.vue?vue&type=style&index=0&id=de64efb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de64efb6",
  null
  
)

export default component.exports